import React from 'react';
import { Award } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import { tx } from '@/translations/translations';

const CertificacionSection = () => {
  const { language } = useLanguage();

  return (
    <section id="certificacion" className="py-10 md:py-16 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-3xl overflow-hidden bg-white border border-slate-200 shadow-lg">
          <div className="relative p-8 sm:p-12">
            <div className="text-center mb-10">
              <div className="inline-flex items-center gap-2 bg-amber-50 border border-amber-200 rounded-full px-4 py-1.5 mb-5">
                <Award className="w-4 h-4 text-amber-600" />
                <span className="text-amber-700 text-xs font-bold uppercase tracking-widest">
                  {tx(language, 'Certificación Oficial', 'Official Certification', 'הסמכה רשמית')}
                </span>
              </div>
              <h3 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-3">
                {tx(language, 'Certificación Kosher', 'Kosher Certification', 'תעודת כשרות')}
              </h3>
              <p className="text-slate-500 max-w-xl mx-auto text-sm sm:text-base leading-relaxed">
                {tx(language, 'Todos nuestros productos cuentan con certificación kosher, garantizando el cumplimiento de los más altos estándares halájicos.', 'All our products have kosher certification, guaranteeing compliance with the highest halachic standards.', 'כל המוצרים שלנו עם תעודת כשרות, המבטיחה עמידה בסטנדרטים ההלכתיים הגבוהים ביותר.')}
              </p>
            </div>

            <div className="grid grid-cols-2 gap-8 sm:gap-12 max-w-lg mx-auto">
              <div className="flex flex-col items-center">
                <div className="w-44 h-44 sm:w-52 sm:h-52 rounded-full bg-slate-900 flex items-center justify-center shadow-xl shadow-slate-900/20 overflow-hidden">
                  <img src="/products/seal-mehadrin.webp" alt="Mehadrin - Rav Yosef Tawil" className="w-[90%] h-[90%] object-contain" />
                </div>
                <span className="text-sm text-slate-700 font-semibold text-center mt-5 leading-tight">
                  {tx(language, <>Composición y medidas<br/>de prenda certificadas</>, <>Certified garment<br/>composition and measurements</>, <>הרכב ומידות<br/>בגד מוסמכים</>)}
                </span>
              </div>
              <div className="flex flex-col items-center">
                <div className="w-44 h-44 sm:w-52 sm:h-52 rounded-full bg-slate-900 flex items-center justify-center shadow-xl shadow-slate-900/20 overflow-hidden">
                  <img src="/products/seal-badatz.webp" alt="Badatz Yerushalayim" className="w-[90%] h-[90%] object-contain" />
                </div>
                <span className="text-sm text-slate-700 font-semibold text-center mt-5 leading-tight">
                  {tx(language, <>Hilos con<br/>certificación</>, <>Certified<br/>threads</>, <>חוטים עם<br/>תעודת כשרות</>)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertificacionSection;
